import { ToggleSwitchCoreUniDriver } from './ToggleSwitchCore/ToggleSwitchCore.uni.driver';

export interface ToggleSwitchUniDriver extends ToggleSwitchCoreUniDriver {
  getSize: () => Promise<string>;
  getSkin: () => Promise<string>;
}
